module.exports = __webpack_public_path__ + "img/logo-legislaPublico.7cc25a20.svg";